@let _message = message();
@let _buttons = _message.buttons;

@if (_message.icon === 'progress-circle') {
  <ideals-progress-circle [value]="(_message.progress$ | async) ?? 0"/>
} @else {
  <span class="ideals-toast-icon" [class]="_message.icon"></span>
}

<div
  fxFlex
  fxGap="medium"
  fxLayout="column"
>
  <div class="ideals-toast-detail ideals-text-wrap">{{ _message.detail }}</div>

  @if (_buttons.length) {
    <div class="ideals-buttons-group" fxGap>
      @for (button of _buttons; track button) {
        <button
          appearance="text"
          [class]="'ideals-toast-btn ideals-toast-btn-' + $index"
          idealsButton
          [label]="button.label"
          (click)="handleButtonClick(button)"
          [data-ideals]="'ideals-toast-btn-' + $index"
        ></button>
      }

      @for (button of _buttons; track button) {
        @if (button.shortcut; as shortcut) {
          <div class="ideals-toast-shortcut-wrapper" [class]="'ideals-toast-shortcut-wrapper-' + $index">
            <span class="ideals-text-nowrap ideals-toast-shortcut-label">
              {{ getShortcutLabel(shortcut) }}
            </span>
          </div>
        }
      }
    </div>
  }
</div>

@if (_message.closable) {
  <button
    class="ideals-toast-close-icon"
    idealsIconButton="icon-close"
    size="large"
    (click)="close()"
    data-ideals="toast-close-btn"
  ></button>
}
